import { Controller } from "@hotwired/stimulus"

// The session page's table of contents (TMS-1614). Collapsing it hands the
// player the full width of the content area and leaves the reopen control
// showing; the choice is remembered in this browser, so the next session opens
// the same way. On connect the current session is scrolled into view inside
// the list, never by scrolling the page.
const COLLAPSED_KEY = "tms:virtual-meeting:toc-collapsed"

export default class extends Controller {
  static targets = ["panel", "list", "current", "collapseButton", "openButton"]
  static classes = ["collapsed"]

  connect() {
    this.apply(this.readCollapsed())
    this.revealCurrent()
  }

  collapse() {
    this.apply(true)
    this.writeCollapsed(true)
    if (this.hasOpenButtonTarget) this.openButtonTarget.focus()
  }

  open() {
    this.apply(false)
    this.writeCollapsed(false)
    if (this.hasCollapseButtonTarget) this.collapseButtonTarget.focus()
    this.revealCurrent()
  }

  apply(collapsed) {
    this.element.classList.toggle(this.collapsedClass, collapsed)
    if (this.hasPanelTarget) this.panelTarget.hidden = collapsed
    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.hidden = !collapsed
      this.openButtonTarget.setAttribute("aria-expanded", String(!collapsed))
    }
    if (this.hasCollapseButtonTarget) this.collapseButtonTarget.setAttribute("aria-expanded", String(!collapsed))
  }

  revealCurrent() {
    if (!this.hasListTarget || !this.hasCurrentTarget || this.listTarget.scrollHeight <= this.listTarget.clientHeight) return

    const list = this.listTarget
    const row = this.currentTarget
    // The list is the rows' offset parent (position: relative), so offsetTop is within it.
    list.scrollTop = row.offsetTop - (list.clientHeight - row.offsetHeight) / 2
  }

  readCollapsed() {
    try { return window.localStorage.getItem(COLLAPSED_KEY) === "1" } catch (_) { return false }
  }

  writeCollapsed(collapsed) {
    try { window.localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0") } catch (_) { /* storage unavailable */ }
  }
}
